import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  AccountStatus = 'AccountStatus',
  RequiredDocuments = 'RequiredDocuments',
}

export const queryKeys = {
  accountStatus: (clientId: string, accountId: string) => [
    QueryFeature.ApexStatusViews,
    QueryKey.AccountStatus,
    clientId,
    accountId,
  ],

  requiredDocuments: (clientId: string, accountId: string) => [
    QueryFeature.ApexStatusViews,
    QueryKey.RequiredDocuments,
    clientId,
    accountId,
  ],
};
